var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4086 10.9991L15.7045 6.71268C15.8926 6.52453 15.9983 6.26935 15.9983 6.00326C15.9983 5.73718 15.8926 5.482 15.7045 5.29385C15.5164 5.1057 15.2612 5 14.9952 5C14.7291 5 14.474 5.1057 14.2859 5.29385L10 9.59031L5.71414 5.29385C5.52602 5.1057 5.27087 5 5.00483 5C4.73878 5 4.48363 5.1057 4.29551 5.29385C4.10739 5.482 4.0017 5.73718 4.0017 6.00326C4.0017 6.26935 4.10739 6.52453 4.29551 6.71268L8.59136 10.9991L4.29551 15.2856C4.20187 15.3785 4.12755 15.489 4.07683 15.6108C4.02611 15.7325 4 15.8631 4 15.995C4 16.1269 4.02611 16.2575 4.07683 16.3793C4.12755 16.501 4.20187 16.6116 4.29551 16.7044C4.38839 16.7981 4.49888 16.8724 4.62062 16.9232C4.74236 16.9739 4.87294 17 5.00483 17C5.13671 17 5.26729 16.9739 5.38903 16.9232C5.51077 16.8724 5.62127 16.7981 5.71414 16.7044L10 12.408L14.2859 16.7044C14.3787 16.7981 14.4892 16.8724 14.611 16.9232C14.7327 16.9739 14.8633 17 14.9952 17C15.1271 17 15.2576 16.9739 15.3794 16.9232C15.5011 16.8724 15.6116 16.7981 15.7045 16.7044C15.7981 16.6116 15.8724 16.501 15.9232 16.3793C15.9739 16.2575 16 16.1269 16 15.995C16 15.8631 15.9739 15.7325 15.9232 15.6108C15.8724 15.489 15.7981 15.3785 15.7045 15.2856L11.4086 10.9991Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.69ef5841de77181ecdf5d7cfed40e814.svg";
export { ForwardRef as ReactComponent };